import { Icon } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { useFeature } from 'hooks/useFeature';
import { Button as LegacyLink } from 'ui/elements/Button';

export const GWPOld_CalloutButton = ({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) => {
  const hideCalloutMessage = useFeature('HIDE_CALLOUT_MESSAGE');
  const translate = useTranslate();

  return (
    <LegacyLink
      dataTestId="gwp-promo-link"
      className={`w-full ${className}`}
      onClick={onClick}
      variant="secondary"
    >
      <Icon name="gift" size="2xl" />
      <div className="flex-grow">
        {hideCalloutMessage ? (
          <h2 className="font-bold uppercase">{translate('bonusItems')}</h2>
        ) : (
          <>
            <h2 className="font-bold uppercase">
              {translate('claimYourGiftItems')}
            </h2>
          </>
        )}
      </div>
    </LegacyLink>
  );
};
